export const CookieKeys = {
  geolocation: 'geo',
  preferredStoreKey: 'store-key',
  postcode: 'postcode',
}
